import {$, w} from './constants';

export function fondos(){

    $('[data-fondo]').on('click', function(){
        $('[data-fondo]').not(this).removeClass('active');
        $(this).addClass('active');
        let post_id = $(this).data('fondo');
        fetch_fondo( post_id );
    });

    $('#fondos_select').on('change', function(){
        let post_id = $(this).val();
        fetch_fondo( post_id );
	});
}

export function avisos(){
    console.log('Avisos')
    $(document).ready(function() {
        $(function(){
            console.log('Primera carga')
            let type_btn = $('#filter_types').find('.filter_aviso_type.active');
            let type = $(type_btn).data('type');
            let year = $('#select_years').val();
            fetch_aviso( type, year);
        });
    });

    $('[data-type]').on('click', function(){
        $('[data-type]').not(this).removeClass('active');
        $(this).addClass('active');
        let type = $(this).data('type');
        let year = $('#select_years').val();
        fetch_aviso( type, year);
    });

    $('#select_years').on('change', function(){
        console.log('Cambio')
        let year = $(this).val();
        let type_btn = $('#filter_types').find('.filter_aviso_type.active');
        let type = $(type_btn).data('type');
        fetch_aviso( type, year );
	});
}

const fetch_fondo = (post_id) => {
    $.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: { 
			action : 'fondo', 
			post: post_id,
		},
		success: function(data){
			$('#fondos_container').empty();
			$('#fondos_container').html(data);
            $('[data-fondo]').on('click', function(){
                $('[data-fondo]').not(this).removeClass('active');
                $(this).addClass('active');
                let post_id = $(this).data('fondo');
                fetch_fondo( post_id );
            });
            $('#fondos_select').on( 'change', function(){
                let post_id = $(this).val();
                fetch_fondo( post_id );
            });
		},
		error: function(errors){
			console.log( errors );
		}
	});
}

const fetch_aviso = (type, year) => {
    $.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: { 
			action : 'aviso', 
			type: type,
            year: year
		},
		success: function(data){
			$('#avisos_container').empty();
			$('#avisos_container').html(data);
		},
		error: function(errors){
			console.log( errors );
		}
	});
}